// extracted by mini-css-extract-plugin
export var bd = "br--";
export var bigger = "br-2";
export var detail = "br-1";
export var downloadBar = "br-_";
export var footBottom = "br-Z";
export var footBottomDesc = "br-4";
export var footLine = "br-X";
export var footTop = "br-U";
export var footTopAddress = "br-Y";
export var footTopDesc = "br-V";
export var footTopText = "br-W";
export var footerM = "br-T";
export var ft = "br-5";
export var logo = "br-0";
export var minWidthLimit = "br-S";
export var red = "br-3";